/*
 * layout (root)
 */
import { createRootRoute, Link, Outlet } from "@tanstack/react-router"
import { Container, Header, Page } from "@timeprox/react/ui"
import appCss from "../global.css?url"
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import Layout from "../layout"
import Providers from "../providers"

function RootLayout() {
	return (
		<Providers>
			<Layout>
				<Outlet />
				{/* <TanStackRouterDevtools
						initialIsOpen={false}
						position={"bottom-right"}
					/> */}
			</Layout>
		</Providers>
	)
}

export const Route = createRootRoute({
	head: () => ({
		meta: [
			{ charSet: "utf-8" },
			{ name: "viewport", content: "width=device-width, initial-scale=1" },
			{ title: "TanStack Start Starter" },
		],
		links: [{ rel: "stylesheet", href: appCss }],
	}),
	component: RootLayout,
	notFoundComponent: () => (
		<Page>
			<Container className={"justify-center"}>
				<Header>Page Not Found</Header>
				<p>The page you are looking for does not exist</p>
				<span>
					Go back to <Link to={"/"}>Home</Link>
				</span>
			</Container>
		</Page>
	),
})
